import { combineReducers } from "@reduxjs/toolkit";
import proposalConfigSlice from "../modules/Dynamic-Claim/proposal.slice";
import themeSlice from "../modules/Dynamic-Claim/theme.slice";
export default combineReducers({
  globalSlice: "xyz",
  proposalConfig: proposalConfigSlice,
  theme: themeSlice,
});
